// Components
import { useEffect } from 'react';
import HistoryTime from 'components/HistoryTime';
// Slices
import { fetchLanguages } from 'slices/language.slice';
import { useAppDispatch } from 'slices/store';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

type TGeneralInfoProps = {
  value?: any;
  onChangeValue: (type: string, value: any) => void;
};
export const GeneralInfo = ({ value, onChangeValue }: TGeneralInfoProps) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchLanguages());
  }, [dispatch]);
  return (
    <TEDrawerSection label="General Info">
      <div className="wrapper-section">
        <div className="section-item">
          <TEInput.Input
            value={value.name}
            onChange={(e) => onChangeValue('name', e)}
            label="Name"
            tooltip="Name"
            placeholder="New object type"
            data-testid="object-name"
          />
          <TEInput.TextArea
            value={value.description}
            onChange={(e) => onChangeValue('description', e)}
            label="Description"
            tooltip="Description"
            data-testid="description"
          />
          <TEInput.Input
            value={value.extId}
            onChange={(e) => onChangeValue('extId', e)}
            label="Exd.Id"
            tooltip="Exd.Id"
            data-testid="exd-id"
          />
        </div>
        <div className="section-item">
          <TEInput.Input
            value={value.id}
            onChange={(e) => onChangeValue('id', e)}
            disabled
            label="ID"
            tooltip="ID"
          />
          <TEInput.Switch
            checked={value.active}
            onChange={(val) => onChangeValue('active', val)}
            label="Active"
            tooltip="Active"
            data-testid="active"
          />
          <TEInput.Switch
            checked={value.personalData}
            onChange={(val) => onChangeValue('personalData', val)}
            label="Personal Data"
            tooltip="Personal Data"
            data-testid="personal-data"
          />
          <div className="te-drawer-input">
            <HistoryTime history={value?.history} />
          </div>
        </div>
      </div>
    </TEDrawerSection>
  );
};
